import Vue, { CreateElement } from '@src/vue'
import SessionManager from '@src/lib/session_manager'
import { Component } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import { Dialog } from '@src/components/dialog/dialog'
import { Input } from '@src/elements/input/input'
import { Loader } from '@src/components/loading-screen/loader/loader'
import { LanguageSwitch } from '@src/components/language-switch/language-switch'
import Cookies from '@src/lib/cookies'
import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import { Caption } from '@src/elements/typography/typography'
import { InputFootnote } from '@src/elements/input/input-footnote'
import { Logo } from '@src/elements/logo/logo'

import './login.sass'
import { UserState } from '@src/data/user'

@Component
export class LoginRoute extends Vue {

  name: string = ''
  password: string = ''

  error: boolean = false
  clubDisabled: boolean = false
  requestInProgress: boolean = false

  apiClient: ApiClient

  constructor () {
    super()
    this.apiClient = new ApiClient()
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.LOGIN.SUBMIT_BUTTON')}`
  }

  attemptLogin () {
    this.requestInProgress = true
    this.error = false
    this.clubDisabled = false

    return SessionManager.Instance.loginWithPassword(this.name, this.password)
      .then(user => {
        if (user.state === UserState.DEACTIVATED) {
          this.error = true
          SessionManager.Instance.logout()
        } else {
          this.$store.dispatch('login', user)
          this.updatePlatformLanguage(user)
          this.goToLandingPage()
        }
      })
      .catch(err => {
        console.log('Login failed', err)
        if (err.status === 403) {
          this.clubDisabled = true
        }
        this.error = true
      })
      .finally(() => this.requestInProgress = false)
  }

  updatePlatformLanguage (user) {
    const locale = Cookies.get('Locale')

    if (locale && user && locale !== user.locale) {
      this.apiClient.resetAuthToken()
      this.apiClient.put(API.TRAINERS_API.PROFILE, { profile: ({ locale: locale }) })
        .catch(error => console.log('error saving language', error))
    }
  }

  goToLandingPage () {
    if (SessionManager.Instance.isManager()) {
      this.$router.push('/trainers/platform/members')
    } else {
      this.$router.push(`/members/${this.$store.state.user.id}/training`)
    }
  }

  setName (value) {
    this.name = value
  }

  render (h: CreateElement) {
    return <div class='login-page'>

      <Logo type='gradient' />

      <Dialog>
        <div class='login-form' onKeyup={(event: KeyboardEvent) => {
          if (event.keyCode === 13) {
            return this.attemptLogin()
          }
        }}>

          <Input ref='input-name' label={this.$t('USERNAME')} autofocus={true} valueChanged={this.setName}
                 value={this.name} class={this.error ? 'error' : ''} autocomplete='email' />
          <Input type='password' ref='input-password' label={this.$t('PASSWORD')} valueChanged={(value: string) => this.password = value}
                 value={this.password} class={this.error ? 'error' : ''} autocomplete='current-password' />

          {this.error ? <InputFootnote class='error login-error'>{this.clubDisabled ? this.$t('PAGE.LOGIN.CLUB_DISABLED') : this.$t('PAGE.LOGIN.ERROR')}</InputFootnote> : null}

          <Caption class='reset-password-link' ref='reset-password-link'>
            <span onClick={() => this.$router.push('trainers/reset-password')}>{this.$t('PAGE.LOGIN.RESET_PASSWORD_LINK')}</span></Caption>

          {this.requestInProgress ?
            <Loader color='white' />
            : <Button class='submit-button' ref='button-submit' label={this.$t('PAGE.LOGIN.SUBMIT_BUTTON')} disabled={!(this.name && this.password)} click={this.attemptLogin}
                      type='elevated' />}
        </div>

        <LanguageSwitch />
      </Dialog>
    </div>
  }
}
